/**
 * The text to show for an error caught from dispatch(thunk).unwrap().
 * Our thunks reject with the backend's message (a string), so .unwrap() throws that string;
 * anything unexpected is an Error with .message.
 * @param {unknown} error - What the catch block received
 * @param {string} fallback - Shown when there is no message at all
 * @returns {string}
 */
export const getErrorMessage = (error, fallback) =>
	(typeof error === "string" ? error : error?.message) || fallback;
